<template>
  <div id="app">
<!--    <div>{{'orgID:' + orgID}}&nbsp;&nbsp;{{'startTime:' + startTime}}&nbsp;&nbsp;{{'stopTime:' + stopTime}}</div>-->
    <flexible />
    <div><router-view /></div>
  </div>
</template>
<script>

import vHeader from '@/components/vHeader';
import flexible from "@/components/flexible-ui/index.vue";
import { getCurrentMemberInfo } from '@/utils/api'
// eslint-disable-next-line no-unused-vars
import { orderSource, deviceType } from '@/utils/env'
export default {
  name: 'app',
  components: { flexible, vHeader },
  data () {
    return {
      showTop: false,
      token: '',
      orgID: '',
      startTime: '',
      stopTime: '',
      addBizChannel: '',
      orderSource: orderSource,
      citycode:"",
      cityname:""
    }
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        this.showTop = this.$route.meta.show || false;
      },
      deep: true
    }
  },
  created () {
    window.userExport = this.userExport;
    if( localStorage.getItem('token') ){ localStorage.removeItem('token') }
    if( localStorage.getItem('orgID') ){ localStorage.removeItem('orgID') }
    if( localStorage.getItem('startTime') ){ localStorage.removeItem('startTime') }
    if( localStorage.getItem('stopTime') ){ localStorage.removeItem('stopTime') }
    if( localStorage.getItem('addBizChannel') ){ localStorage.removeItem('addBizChannel')}
    if( localStorage.getItem('citycode') ){ localStorage.removeItem('citycode') }
    if( localStorage.getItem('cityname') ){ localStorage.removeItem('cityname') }
    if( process.env.NODE_ENV === 'development' ) {
      // dev 开发环境
      localStorage.setItem('token', 'aaquehYvmV6T2iHBc4AbhqIsagH6ESNZioXFGO0B96WU9+AgkDTMMw==');
    }
    if( process.env.NODE_ENV === 'production' ){
      // build 生产环境
    }
  },
  mounted () {
    this.getUserExport();
  },
  methods:{
    getUserExport () {
      let res = null;
      let userAgent = navigator.userAgent;
      if ( /DFZCFlutterAPPAndroid/.test(userAgent) ) {
        window.userExport2.postMessage('1');
        setTimeout(()=>{
          res = localStorage.getItem('getToken') || '';
          if( res ){
            this.userExport(res);
          }
        },80);
        return;
      }
      if( this.orderSource==16){ //安卓
        res = window.dfpanda.userExport();
      } else if( this.orderSource==17 ){
        res = JSON.stringify(window.iosInfo);
      }
      if( res ){
        this.userExport(res);
      }
    },
    userExport(resd){
      let res = {};
      if( typeof resd === 'string' ){
        res = JSON.parse(resd);
      } else {
        res = resd;
      }
      if( res.token ){
        localStorage.setItem('token', res.token);
        this.token = res.token;
        this.getUserInfo()
      }
      if( res.orgID ){ localStorage.setItem('orgID', res.orgID);this.orgID=res.orgID; }
      if( res.startTime ){ localStorage.setItem('startTime', res.startTime);this.startTime=res.startTime; }
      if( res.stopTime ){ localStorage.setItem('stopTime', res.stopTime);this.stopTime=res.stopTime; }
      if( res.startTime ){ localStorage.setItem('startTime', res.startTime);this.startTime=res.startTime; }
      if( res.stopTime ){ localStorage.setItem('stopTime', res.stopTime);this.stopTime=res.stopTime; }
      if( res.bizChannel ){ localStorage.setItem('bizChannel', res.bizChannel);this.bizChannel=res.bizChannel; }
      if( res.citycode ){ localStorage.setItem('citycode', res.citycode);this.citycode=res.citycode; }
      if( res.cityname ){ localStorage.setItem('cityname', res.cityname);this.cityname=res.cityname; }
      if( res.addBizChannel ){ localStorage.setItem('addBizChannel', res.bizChannel);this.bizChannel=res.bizChannel; }
    },
    async getUserInfo () {
      let token = localStorage.getItem('token');
      if( token ) {
        let res = await getCurrentMemberInfo({
          showError: false
        });
        if( res.Code==100 ){
          localStorage.setItem('userInfo', JSON.stringify(res.Data))
        }
      } else {
        localStorage.removeItem('userInfo')
      }
    }
  }
}
</script>
<style lang="scss">
html, body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, i, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td {
  margin: 0;
  padding: 0;
  list-style: none;
  font-style: normal;
  text-decoration: none;
  font-weight: normal;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-tap-highlight-color:transparent;
  -webkit-font-smoothing: antialiased;
  outline: none;
  //&:hover{
  //  outline: none;
  //}
}
input, textarea{
  border: none;
}
img {
  vertical-align: top;
}
body {
  font-size: 24px;
  background-color: #fff;
  /*-moz-text-size-adjust: none;*/
  /*-webkit-text-size-adjust: none;*/
}

a {
  text-decoration: none;
  color: #85898d ;
  -webkit-tap-highlight-color: transparent;
}
html, body {
  width: 100%;
}
* {
  /*box-sizing: border-box;*/
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.textCenter { text-align: center; }
.textLeft { text-align: left; }
.textRight { text-align: right; }
</style>
